import { createIcon } from '@mote/ui/components/icon'
import { defaultProps } from './defaultProps'

export const RegenerativeBoltIcon = createIcon({
  displayName: 'RegenerativeBoltIcon',
  path: [
    <path
      fill='currentColor'
      d='M12.175 23c-2.017 0-3.858-.471-5.525-1.413-1.667-.941-3.05-2.279-4.15-4.012v3.4H1V15h5.95v1.5H3.6c.95 1.583 2.175 2.812 3.675 3.687a9.554 9.554 0 0 0 4.9 1.313c2.017 0 3.833-.588 5.45-1.763 1.617-1.175 2.742-2.72 3.375-4.637l1.475.325c-.717 2.267-2.02 4.096-3.913 5.487C16.672 22.304 14.543 23 12.175 23ZM1.05 11a11.43 11.43 0 0 1 .8-3.213 10.97 10.97 0 0 1 1.7-2.812L4.625 6.05c-.583.75-1.05 1.541-1.4 2.375A9.329 9.329 0 0 0 2.55 11h-1.5Zm4.975-6.35-1.05-1.1c.9-.734 1.858-1.309 2.875-1.725a10.969 10.969 0 0 1 3.2-.775v1.5a8.654 8.654 0 0 0-2.525.637c-.817.342-1.65.83-2.5 1.463Zm11.95 0c-.75-.6-1.542-1.08-2.375-1.438A8.534 8.534 0 0 0 13 2.55v-1.5c1.133.1 2.204.358 3.212.775 1.009.416 1.946.991 2.813 1.725l-1.05 1.1ZM21.45 11a8.372 8.372 0 0 0-.7-2.575A10.973 10.973 0 0 0 19.275 6l1.05-1.1c.767.9 1.375 1.87 1.825 2.912a9.909 9.909 0 0 1 .8 3.188h-1.5Z'
    />,
    <path
      fill='currentColor'
      d='M11.398 18h-.6l.6-4.667h-2.1c-.348 0-.342-.213-.228-.44.114-.226.03-.053.042-.08.774-1.52 1.938-3.786 3.486-6.813h.6l-.6 4.667h2.1c.294 0 .336.22.282.34l-.042.1A3257.89 3257.89 0 0 0 11.398 18Z'
    />
  ],
  defaultProps: defaultProps
})
